import { Component } from '@angular/core';

@Component({
  selector: 'app-pagina-sem-autorizacao',
  templateUrl: './pagina-sem-autorizacao.component.html'
})
export class PaginaSemAutorizacaoComponent {

}
